import React, { useState } from 'react';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import "../../index.css";
import './style.css';

const DetailBox = styled('div')(({ theme }) => ({
  backgroundColor: '#313940',
  boxShadow: theme.shadows[5],
  padding: theme.spacing(3),
  color: 'white',
  maxWidth: 300,
  minWidth: 280,
  overflowY: 'auto',
}));

const Compartilhar = ({ anchorEl, onClose, cardUrl }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(cardUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 5000);
  };

  const handleClose = () => {
    onClose();
  };

  const open = Boolean(anchorEl);

  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <DetailBox>
          <p className='paragraph-members'>Compartilhar Cartão</p>
          <p style={{ marginLeft: '5px' }} className='paragraph-copyCard'>Este é o link do seu cartão</p>
          <input
            type="text"
            value={cardUrl}
            readOnly
            style={{
              width: '250px',
              padding: '10px',
              borderRadius: '6px',
              border: 'none',
              marginBottom: '20px',
            }}
            className='input-copyCard'
          />
          <Button
            variant="outlined"
            onClick={copyToClipboard}
            className= 'button-copyCard'
          >
            {copied ? <CheckRoundedIcon /> : 'Copiar URL'}
          </Button>
        </DetailBox>
      </Popover>
    </Box>
  );
};

export default Compartilhar;
